export const idbConfig = {
  databaseName: "pat-tool-db",
  version: 1,
  stores: [
    {
      name: "templates",
      id: { keyPath: "id", autoIncrement: true },
      indices: [
        { name: "id", keyPath: "id" },
        { name: "data", keyPath: "data" },
        { name: "currency", keyPath: "currency" },
        { name: "symbol", keyPath: "symbol" },
        { name: "indicators", keyPath: "indicators" },
        { name: "inputs", keyPath: "inputs" },
        { name: "name", keyPath: "name" },
      ],
    },
    {
      name: "settingsUser",
      id: { keyPath: "id", autoIncrement: true },
      indices: [
        { name: "id", keyPath: "id" },
        { name: "templateId", keyPath: "templateId" },
      ],
    },

    {
      name: "assessments",
      id: { keyPath: "id", autoIncrement: true },
      indices: [
        { name: "id", keyPath: "id" },
        { name: "results", keyPath: "results" },
        { name: "userId", keyPath: "userId" },
        { name: "templateId", keyPath: "templateId" },
        { name: "status", keyPath: "status" },
        { name: "inputs", keyPath: "inputs" },
        { name: "clinicId", keyPath: "clinicId" },
        { name: "doctorId", keyPath: "doctorId" },
        { name: "calculatedValues", keyPath: "calculatedValues" },
      ],
    },
  ],
};
